<template>
	<div id="paiche">
		<div class="null-box" v-if="loaded && reserveList.length<1">
			<i class="iconfont icon-ico_meiyoushuju"></i>
			<p>没有内容</p>
		</div>
		<div title="加载"
			v-infinite-scroll="loadMore"
			infinite-scroll-disabled="loading"
			infinite-scroll-distance="50">
			<div class='news-box'>
				<div class='news-list' v-for="item in reserveList">
					<div class="title">
						{{item.address}}
						<span>{{item.create_at}}</span>
					</div>
					<div class="params">
						<div>科目：{{item.km}}</div>
						<div>预约时间：{{item.reserve_time}}</div>
					</div>
					<div class="params">
						<div>真实姓名：{{item.realname}}</div>
						<div v-on:click="event_call">电话：{{item.phone}}</div>
					</div>
					<div class="content">
						其它要求：{{item.content ? item.content : '无'}}
					</div>
					<div class="btn-group" v-if="!item.send">
						<div class="btn" v-on:click="event_send(item)">我有车</div>
					</div>
					<div class="btn-group" v-if="item.send">
						<div class="btn" style="background-color:#DDDDDD;">已派车</div>
					</div>
				</div>
			</div>
			<p v-show="loading" class="loading-tips" style="text-align:center;">
				<wv-spinner type="snake" color="#444" :size="24"/>
			</p>
		</div>
		<wv-actionsheet 
		  type="ios" 
		  title="<h3>请选择时段</h3>" 
		  :actions="actions" 
		  cancel-text="取消" 
		  v-model="timelimitShow"
		/>
	</div>
</template>

<script>
export default {
  data () {
    return {
		loaded:false,
		loading:false,
		reserveList:[],
		page:1,
		timelimitShow:false,
		timelimit:'',
		itemin:null,
		actions:[
		  {
			name: '上午',
			method: () => {
			  this.timelimit = '上午'
			  this.postSend()
			}
		  },
		  {
			name: '下午',
			method: () => {
			  this.timelimit = '下午'
			  this.postSend()
			}
		  }
		]
	}
  },
  created(){
	if(!this.$store.state.userInfo.driver_level.reserved){
		this.$wx.showToast('您没有管理车辆预约的权限')
		this.$router.push('/News')
		return false;
	}
  },
  methods: {
		event_call(tel){
			window.open(tel)
		},
		event_send(item){
			this.timelimitShow = true
			this.itemin = item
		},
		postSend(){
			if(this.timelimit == ''){
				this.$wx.showToast('请选择时段')
				return false;
			}	
			this.$wx.showLoading('正在处理');
			this.$app.pr('/api/reserve/post',{
				timelimit:this.timelimit,
				id:this.itemin.id
			}).then((res) => {
				this.$wx.hideLoading()
				this.itemin.send = res.data
			}).catch((res) => {
				this.$wx.showToast('系统错误，请重试')
				this.$wx.hideLoading()
			})
		},
		loadMore(){
			if(this.loaded){
				return false
			}
			this.loading = true
			this.$https.post("/api/reserve/lists",this.$qs.stringify({
				token:this.$store.state.token,
				page:this.page,
				type:this.type
			})).then((res) => {
				if(!res.data.data.power){
					//this.$wx.showToast('您没有权限进行此操作');
					//this.$wx.navigateBack();
					//return false;
				}
				if(res.data.data.lists.length < 1){
					this.loaded = true;
				}
				for(var n in res.data.data.lists){
					this.reserveList.push(res.data.data.lists[n])
				}
				this.loading = false
				this.page++;
			}).catch(() => {
				
			});
		}
  }
}
</script>

<style scoped>
	#paiche{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.btn-group{
	}
	.btn-group .btn{
		background:linear-gradient(to right, #fa8d60, #e76025);
		    height: 12vw;
			display: block;
			margin: 0vw 3vw;
			text-align: center;
			color: #FFFFFF;
			background: -webkit-gradient(linear, left top, right top, from(#fa8d60), to(#e76025));
			background: linear-gradient(to right, #fa8d60, #e76025);
			font-size: 4vw;
			line-height: 12vw;
			border-radius: 10px;
	}
	.news-list{
		background-color:#FFFFFF;
		font-size:4.2vw;
		margin-bottom:3vw;
		padding-bottom:2vw;
	}
	.news-list .title{
		padding:0vw 3vw;
		line-height:10vw;
		color:#5D5D5D;
		border-bottom:1px solid #DDDDDD;
		border-top:1px solid #EEEEEE;
		box-shadow:0px -5px 5px #F8F8F8 inset;
		margin-bottom:10px;
	}
	.news-list .title span{
		float:right;
		font-size:3.8vw;
		color:#898989;
		line-height:10vw;
	}
	.news-list .params{
		padding:1vw 3vw;
		display:flex;
		display:-webkit-flex;
		line-height:6vw;
	}
	.news-list .params div{
		flex:1;
		color:#898989;
		-webkit-flex:1;
	}
	.news-list .params div:last-child{
		text-align:right;
	}
	.news-list .content{
		color:#898989;
		margin:1.5vw 3vw;
		background-color:#F8F8F8;
		border-radius:5px;
		padding:3vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/Paiche.vue